/* eslint-disable */
// @ts-nocheck
import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { Dropdown, Tooltip } from '../../core';
import { FRAUD_RULE_NAMES } from '../../../../main/screens/ScreenAdsFraud/fraudConstants';

type Props = {
  blockedEventIndicators: Record<string, any>;
  blockedEventIndicator: string;
  defaultBlockedEventIndicator: string;
  updateBlockedEventType: (e: Record<string, any>) => void;
  updateOrganic: (e: Record<string, any>) => void;
  fraudIndicators: Record<string, any>;
  fraudIndicator: string;
  defaultFraudIndicator: string;
  updateFraudType: (e: Record<string, any>) => void;
  updateQuery?: (arg0: Record<string, any>) => void;
  dimension: string;
};

class FraudSelect extends PureComponent<Props> {
  renderFraudTypeOption = (option: Record<string, any>) => (
    <div className="h_d-f h_jc-sb">
      {option.label}
      {option.tooltip ? <Tooltip title={option.tooltip} position="right" interactive={false} /> : null}
    </div>
  );

  onBlockedEventTypeSelection = (e: Record<string, any>) => {
    const { updateBlockedEventType, updateQuery, updateOrganic } = this.props;
    updateBlockedEventType(e);
    updateOrganic({
      target: {
        checked: e.organic,
      },
    });
    // add appropriate filter if selected BlockedEvent is a fraud rule name
    const updatedQuery = FRAUD_RULE_NAMES.includes(e.value)
      ? {
          dimensions: e.dimensions || this.props.dimension,
          filter: {
            fields: [
              {
                type: 'in',
                dimension: 'fraud_names',
                values: [e.value.toUpperCase()],
              },
            ],
            type: 'and',
          },
        }
      : {
          dimensions: e.dimensions || this.props.dimension,
          filter: {},
        };
    updateQuery && updateQuery(updatedQuery);
  };

  onFraudTypeSelection = (e: Record<string, any>) => {
    const { updateFraudType, updateQuery } = this.props;
    updateFraudType(e);
    updateQuery &&
      updateQuery({
        dimensions: e.dimensions || this.props.dimension,
        filter: {},
      });
  };

  render() {
    const {
      blockedEventIndicators,
      blockedEventIndicator,
      defaultBlockedEventIndicator,
      fraudIndicators,
      fraudIndicator,
      defaultFraudIndicator,
    } = this.props;

    if (!fraudIndicators) {
      return null;
    }

    return (
      <div className="screen-ads-fraud">
        <div className="dropdown-row">
          <span className="dropdown-label">Show me blocked events for</span>
          <div className="h_d-f">
            <Dropdown
              clearable={false}
              options={R.values(blockedEventIndicators)}
              value={blockedEventIndicator || defaultBlockedEventIndicator}
              onChange={this.onBlockedEventTypeSelection}
              className="blocked-events-dropdown"
              optionRenderer={this.renderFraudTypeOption}
              testid="blocked-events-select"
            />
          </div>
        </div>
        <div className="dropdown-row">
          <span className="dropdown-label">Show me key fraud indicators for</span>
          <div
            style={{
              width: '280px',
            }}
          >
            <Dropdown
              clearable={false}
              options={R.values(fraudIndicators)}
              value={fraudIndicator || defaultFraudIndicator}
              onChange={this.onFraudTypeSelection}
              className="h_mstart-10"
              optionRenderer={this.renderFraudTypeOption}
              testid="fraud-select"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FraudSelect;
